import React from 'react';
import { Row, Col, Table } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import FormAutocomplete from 'components/forms/FormAutocomplete';

import SimplePrompt from 'components/layout/SimplePrompt';

import { ROLE_ERP_MASTER } from 'js/constants';
import may from 'js/security';

class ModelAssetModels extends React.Component {
  addModel = data => {
    let { entity, changeEntity } = this.props;
    let newModel = entity.createValue('models', [], data);
    let newValue = entity.getModels().slice();
    newValue.push(newModel);
    let newEntity = { ...entity.updateValue('models', newValue, []) };

    changeEntity(newEntity);
  };

  handleRemoveClick = (e, index) => {
    e.preventDefault();
    e.stopPropagation();

    this.removeEntry(index);
  };

  removeEntry = index => {
    let { entity, changeEntity } = this.props;
    let newValue = entity.getModels().slice();
    newValue.splice(index, 1);
    let newEntity = { ...entity.updateValue('models', newValue, []) };

    changeEntity(newEntity);
  };

  render() {
    const {
      intl: { messages },
      entityLoaded,
      entity,
      disabled,
      user,
    } = this.props;

    const columns = [messages.name, messages.actions];
    let tBody = [];
    if (entityLoaded && entity.getModels().length) {
      const models = entity.getModels();
      tBody = models.map((model, i) => {
        return (
          <tr key={i} className={i % 2 ? 'even ' : 'odd '}>
            <td className="v-align-middle semi-bold">{model.getName()}</td>
            <td className="v-align-middle text-right">
              {may(ROLE_ERP_MASTER, user.roles) && (
                <SimplePrompt
                  onSuccess={e => {
                    this.handleRemoveClick(e, i);
                  }}
                />
              )}
            </td>
          </tr>
        );
      });
    }

    return (
      <div className="clearfix">
        {entityLoaded && (
          <div className="padding-20 sm-padding-10">
            <Row>
              <Col xs={12} sm={6} md={4}>
                <div className="form-group-attached">
                  <FormAutocomplete
                    returnValueObject
                    label={messages.select_model}
                    name="model"
                    onChange={(property, value) => {
                      this.addModel(value);
                    }}
                    autocompleteType="model"
                    disabled={disabled}
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <Col xs={12}>
                <Table responsive hover>
                  <thead>
                    <tr>
                      {columns.map((column, i) => {
                        return (
                          <th key={i} className={column === messages.actions ? 'text-right' : ''}>
                            {column}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>
                  <ReactCSSTransitionGroup
                    transitionName="tablerows"
                    transitionEnterTimeout={500}
                    transitionLeaveTimeout={1}
                    component="tbody"
                  >
                    {tBody}
                  </ReactCSSTransitionGroup>
                </Table>
              </Col>
            </Row>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.login.user,
  };
};

export default injectIntl(connect(mapStateToProps)(ModelAssetModels));
